import { testimonials } from "@/mocks/webtoons";

export default function Testimonials() {
  return (
    <section id="voices" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-chat-heart-fill"></i>
            读者口碑
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            追漫人的真实反馈
          </h2>
          <p className="mt-4 text-sm text-foreground-600 md:text-base">
            来自不同阶段读者的真实好评，看看他们是怎么按这份韩漫推荐片单入坑的。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg bg-background-100 p-6"
            >
              <i className="ri-double-quotes-l text-3xl text-primary-300"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {t.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-bold text-accent-700">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-950">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}